module.exports = __webpack_public_path__ + "img/hero_2.22ea4381.jpeg";